import makeStore from "../../utils/create-store";
import reducer from "./reducer";

export enum POPUP_TYPE {
    CORRECT,
    WRONG,
    TIME_END,
    THE_END
}

export type ResultPopupModuleState = {
    isDisplayed: boolean,
    type: POPUP_TYPE,
    triesLeft: number
}

const initResultPopupModuleState = {
    isDisplayed: false,
    type: POPUP_TYPE.CORRECT,
    triesLeft: 0
}

export enum RESULT_POPUP_MODULE_ACTION {
    SHOW,
    HIDE
}

export type ResultPopupModuleAction = {
    type: RESULT_POPUP_MODULE_ACTION,
    payload?: any
}

const [
    ResultPopupModuleProvider,
    useResultPopupModuleDispatch,
    useResultPopupModuleState
] = makeStore(reducer, initResultPopupModuleState)


export {
    ResultPopupModuleProvider,
    useResultPopupModuleDispatch,
    useResultPopupModuleState
}
